<template>
    <v-app
        translate="no"
        class="notranslate"
        :class="{
            'cor-fundo-escuro': !$vuetify.theme.dark,
        }"
    >
        <v-main>
            <app-autenticacao />
            <app-carregando />
            <app-mensagem />
            <v-container fluid>
                <v-slide-y-transition mode="out-in">
                    <v-layout column>
                        <router-view v-if="util.pegarDados()" />
                    </v-layout>
                </v-slide-y-transition>
            </v-container>
            <app-mover-topo/>
        </v-main>
        <Menu titulo="Diário de Classe" />

        <app-relacionamento
            v-if="dialogoRelacionamento"
            v-model="dialogoRelacionamento"
            :lista-relacionamentos="listaRelacionamentos"
            @selecionar="selecionar"
        />
    </v-app>
</template>

<script>
import { EventBus } from "@/event-bus.js"

import jwtDecode from "jwt-decode"
import Cookie from "@universidade-franciscana/componente-front/src/utils/cookies.js"

import util from "@/utils/util"

import AppMoverTopo from "./components/AppMoverTopo.vue"

import AppCarregando from "@universidade-franciscana/componente-front/src/components/comuns/AppCarregando.vue"
import AppAutenticacao from "@universidade-franciscana/componente-front/src/components/comuns/AppAutenticacao.vue"
import AppMensagem from "@universidade-franciscana/componente-front/src/components/comuns/AppMensagem.vue"
import Menu from "@universidade-franciscana/componente-front/src/views/Menu.vue"

import AppRelacionamento from "@/components/AppRelacionamento.vue"

import _pessoaRelacionamento from "@/services/pessoa-relacionamento.js"

export default {
  name: "App",

  components: {
    Menu,
    AppMoverTopo,
    AppMensagem,
    AppCarregando,
    AppAutenticacao,
    AppRelacionamento,
  },

  data: () => ({
    util,

    dialogoRelacionamento: false,

    listaRelacionamentos: [],
  }),

  created() {
    if (!sessionStorage.getItem("dados")) {
      this.listarRelacionamento()
    }

    EventBus.$on("abrir-dialogo-relacionamento", () => {
      this.dialogoRelacionamento = true
    })
  },

  beforeDestroy() {
    EventBus.$off("abrir-dialogo-relacionamento") // boa prática
  },

  methods: {
    listarRelacionamento() {
      _pessoaRelacionamento
        .relacionamentos(jwtDecode(Cookie.get("token")).Id)
        .then(x => {
          this.listaRelacionamentos = JSON.parse(x).filter(
            y => y.Fim === null
          )

          if (this.listaRelacionamentos.length === 1) {
            this.selecionar(
              this.listaRelacionamentos[0].Matricula,
              this.listaRelacionamentos[0].Relacionamento,
              this.listaRelacionamentos[0].Criptografado,
              this.listaRelacionamentos.length
            )
          } else {
            this.dialogoRelacionamento = true
          }
        })
    },

    selecionar(matricula, relacionamento,criptografado, quantidade) {
      sessionStorage.setItem(
        "dados",
        JSON.stringify({ matricula, relacionamento, criptografado, quantidade })
      )

      window.location.href = "/"
    },
  },
}
</script>

<style lang="scss">
@import "./styles/base.scss";
</style>
